import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { FilterUtils, DateUtils } from '@ocean/utils'
import { useSelector } from 'hooks'
import { MaintenancePeriod } from 'modules/simulatorTrainings/common/components'
import {
  loadListMaintenancePeriodsData,
  getNearestMaintenancePeriod,
} from 'modules/simulatorTrainings/common/slices/instructor'

const MaintenancePeriodContainer: React.FC = () => {
  const dispatch = useDispatch()
  const nearestMaintenancePeriod = useSelector(({ simulatorTrainingInstructor }) =>
    getNearestMaintenancePeriod(
      simulatorTrainingInstructor.listMaintenancePeriodsData.result?.list.maintenancePeriods
    )
  )

  useEffect(() => {
    const utcNow = new Date(DateUtils.getDateNowGMT())
    const startDate = FilterUtils.formatDate(utcNow)
    const checkingPeriod = DateUtils.addDays(utcNow, 7)
    const endDate = FilterUtils.formatDate(checkingPeriod)
    dispatch(loadListMaintenancePeriodsData({ startDate, endDate }))
  }, [dispatch])

  return <MaintenancePeriod period={nearestMaintenancePeriod} />
}

export default MaintenancePeriodContainer
